import { getAxiosErrorMessage } from "apps/visits/core/utils/axios-error";
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";
import { useAuthenticateUser } from "../api/authenticate-user";
import type { CodeValidationFormValues } from "../components/code-validation-form";
import { useUserState } from "../store/use-user-state";
import { useVouchersDistributionState } from "../store/use-vouchers-distribution-state";
import type { ConfigName } from "../types/config-name";

type UseCodeValidationOptions = {
  configName: ConfigName;
  onSuccess?: () => void;
};

export const useCodeValidation = ({ configName, onSuccess }: UseCodeValidationOptions) => {
  const { voucherDistribution } = useVouchersDistributionState();
  const { user, setUser } = useUserState();
  const { t } = useTranslation();

  const {
    mutate: authenticateUser,
    isLoading,
    error,
  } = useAuthenticateUser({
    config: {
      onSuccess: (data) => {
        setUser({ ...user, isValid: true, externalUid: data.externalUid });
        onSuccess?.();
      },
    },
  });

  const errorMessage = getAxiosErrorMessage(error)
    ? t(`VOUCHERS_DISTRIBUTION.ERRORS.AUTHENTICATE_USER.${getAxiosErrorMessage(error)?.toUpperCase()}`)
    : undefined;

  const handleSubmit = (data: CodeValidationFormValues) => {
    if (!voucherDistribution?.slug || !user?.token) {
      toast.error(t("VOUCHERS_DISTRIBUTION.ERRORS.GENERAL_ERROR"));
      return;
    }
    authenticateUser({
      slug: voucherDistribution.slug,
      code: data.verificationCode,
      configName,
      token: user.token,
    });
  };

  return {
    handleSubmit,
    isLoading,
    errorMessage,
  };
};
